import styled from 'styled-components';

export const TextAlignCenter = styled.span`
  text-align: center;
`;

export const GroupName = styled.span`
  ${({ theme }) => theme.fonts.PoppinsBold};
`;
